import React from "react"
import { Switch as SwitchField } from '@material-ui/core'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import { useTheme } from "@material-ui/styles"
import { switchStyles } from "../../utils"

function Switch({ formik, label, name, labelPlacementEnd, status, value = null, archive = false, onChange, defaultChecked, color = 'primary', setAutoFillState, rights, noLabel, ...rest }) {
  const { theme: { bgColors, colors } } = useTheme()
  const classes = switchStyles(bgColors, colors)()
  const handleChange = (event) => {
    if (archive) {
      const isChecked = event.target.checked
      const newValue = isChecked ? 1 : 0
      formik.setFieldValue(name, newValue)
    } else {
      formik.setFieldValue(name, event.target.checked)
    }
    if (onChange) {
      onChange(event)
    }
  }

  return (
    <FormControlLabel
      name={name && name}
      {...rest}
      classes={{ label: classes.label }}
      labelPlacement={labelPlacementEnd ? "end" : "top"}
      control={<SwitchField
        defaultChecked={defaultChecked}
        onChange={handleChange}
        checked={rights ? defaultChecked : value ? value : formik?.values[name]}
        className={classes.root}
        />}
      disabled={rest?.disabled}
      label={noLabel ? null : label}
    />
  )
}

export default Switch